module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleD7.eb740ce2.png";